import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Skeleton from '@mui/material/Skeleton'
import { ResponsivePaper } from 'components/ResponsivePaper'
import { ShowMoreButton } from 'components/ShowMoreButton/ShowMoreButton'
import { useCMSNotifications } from 'utils/hooks/api/useCMSNotifications'
import { infinityQueryMap } from 'utils/hooks/infinityQueryMap'
import { useIsMobile } from 'utils/hooks/useBreakpoints'

import { NotificationBox } from './NotificationBox'

export const NotificationsBox = () => {
  const { isFetching: isLoadingCMSNotifications, data, fetchNextPage, isInitialLoading } = useCMSNotifications()
  const notifications = infinityQueryMap(data)
  const isMobile = useIsMobile()

  return (
    <Grid container spacing={isMobile ? 2 : 4}>
      {isInitialLoading && (
        <Grid item xs={12}>
          <ResponsivePaper>
            <Box
              component="header"
              sx={(theme) => ({
                fontSize: theme.typography.h1.fontSize,
                lineHeight: 'normal',
                textDecoration: 'none',
              })}
            >
              <Skeleton variant="text" sx={{ fontSize: '32px' }} />
            </Box>
          </ResponsivePaper>
        </Grid>
      )}
      {notifications?.data?.map((notification) => (
        <Grid key={notification.id} item xs={12}>
          <NotificationBox notification={notification} />
        </Grid>
      ))}
      <ShowMoreButton
        items={notifications?.page}
        allItems={notifications?.pages}
        isLoading={isLoadingCMSNotifications}
        onClick={() => fetchNextPage()}
      />
    </Grid>
  )
}
